import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div class="container">

    <div class="text-center mb-5">
      <h2 class="fw-bold">Get in Touch</h2>
      <p class="text-light">
        Zamani Sabios Group welcomes enquiries from organisations across Tanzania, East Africa, and the continent.
        You can reach the team through the details below.
      </p>
    </div>

    <div class="row g-4">

      <div class="col-md-6">
        <div class="p-4 bg-white shadow-sm rounded h-100">
          <div class="d-flex">
            <i class="bi bi-geo-alt-fill text-primary fs-1 me-3"></i>
            <div>
              <h5 class="font-semi-bold text-primary">Office Address</h5>
              <p class="text-muted mb-0">
                <b>P.O. Box</b> 32187, Dar es Salaam.<br/>
				<b>Postal code</b> 14129<br/>
                Makongo, Kinondoni - Dar Es Salaam <br/>
                Changanyikeni Street, Road Makongo, Plot number 105, Block number L<br/>
				<b>House number</b> 105;
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="p-4 bg-white shadow-sm rounded h-100">
          <div className="d-flex">
            <i className="bi bi-envelope-fill text-danger fs-1 me-3"></i>
            <div>
				<h5 className="font-semi-bold text-primary">Email</h5>

				<p className="mb-1">
					<a href="mailto:info@zamanisabios.com" class="text-muted text-decoration-none">
					info@zamanisabios.com
					</a>
				</p>

				<p className="mb-1">
					<a href="mailto:zsg@zamanisabios.com" class="text-muted text-decoration-none">
					zsg@zamanisabios.com
					</a>
				</p>

				<p className="mb-1">
					<a href="mailto:mail@zamanisabios.com" class="text-muted text-decoration-none">
					mail@zamanisabios.com
					</a>
				</p>

				<p className="mb-0">
					<a href="mailto:zamani.sabios@gmail.com" class="text-muted text-decoration-none">
					zamani.sabios@gmail.com
					</a>
				</p>
				</div>

          </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="p-4 bg-white shadow-sm rounded h-100">
          <div className="d-flex">
            <i className="bi bi-telephone-fill text-success fs-1 me-3"></i>
            <div>
				<h5 className="font-semi-bold text-primary">Phone</h5>
				<p className="mb-0">
					<a 
					href="https://wa.me/255767119993" 
					target="_blank" 
					className="text-muted text-decoration-none"
					>
						+255 715 119990 <br/> +255 767 119993
					</a>
				</p>
				</div>

          </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="p-4 bg-white shadow-sm rounded h-100">
          <div className="d-flex">
            <i className="bi bi-clock-fill text-warning fs-1 me-3"></i>
            <div>
              <h5 className="font-semi-bold text-primary">Working Hours</h5>
              <p className="text-muted mb-0">
                Monday to Friday<br/>
                08:00 to 17:00
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div className="text-center mt-5">
      <i className="bi bi-calendar-check-fill text-primary fs-2"></i>
      <p className="mt-3 text-light">
        You may also request a meeting or consultation through email or phone. The team will respond promptly.
      </p>
    </div>

  </div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}